import atlas from 'azure-maps-control';
import { useContext, useEffect } from 'react';
import { AzureMapsContext, IAzureMapsContextProps } from 'react-azure-maps';

import { markers } from '../AzureMapCustomization.constants';

export const useAzureMapCustomization = () => {
  const { isMapReady, mapRef } =
    useContext<IAzureMapsContextProps>(AzureMapsContext);

  useEffect(() => {
    if (isMapReady && mapRef) {
      const { black, red, templateName } = markers;

      mapRef.imageSprite.createFromTemplate(
        black.id,
        templateName,
        black.fillColor,
        black.outlineColor
      );

      mapRef.imageSprite.createFromTemplate(
        red.id,
        templateName,
        red.fillColor,
        red.outlineColor
      );

      // Add pointer cursor when hovering over markers
      const canvas = mapRef.getCanvas();
      
      (mapRef.events as atlas.Map['events']).add('mousemove', (e: atlas.MapMouseEvent) => {
        if (e.shapes && e.shapes.length > 0) {
          canvas.style.cursor = 'pointer';
        } else {
          canvas.style.cursor = 'grab';
        }
      });
    }
  }, [isMapReady, mapRef]);
};
